export default __webpack_public_path__ + "static/media/400-bottles-of-beer-thumb.77227add.jpg";